import moment from "moment";
import { Badge } from "reactstrap";

export const HelperConstant = {
    emailPattern: { pattern: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/ },
    phonenumberPattern: { pattern: /^[0-9]\d{9}$/ },
    amountPattern: { pattern: /(\d)(?=(\d{3})+(?!\d))/g },
    TOAST_TIMEOUT: 2000,
    leadStatus: {
        statusId: 30,
        enumName: 'Converted'
    }
}

export const Toaster_ENUM = {
    create: {
        text: "Created Successfully !!",
        toasterColor: "bg-success",
        textColor: "text-success"
    },
    save: {
        text: "Saved Successfully !!",
        toasterColor: "bg-success",
        textColor: "text-success"
    },
    edit: {
        text: "Edited Successfully !!",
        toasterColor: "bg-success",
        textColor: "text-success"
    },
    update: {
        text: "Updated Successfully !!",
        toasterColor: "bg-success",
        textColor: "text-success"
    },
    delete: {
        text: "Deleted Successfully !!",
        toasterColor: "bg-danger",
        textColor: "text-danger"
    },
    hold: {
        text: "Can't delete this data.It has assosciated dependency !!",
        toasterColor: "bg-warning",
        textColor: "text-warning"
    },
    customer: {
        text: "Converted to Customer Successfully!!",
        toasterColor: "bg-success",
        textColor: "text-success"
    },
    import: {
        text: "Imported Successfully !!",
        toasterColor: "bg-success",
        textColor: "text-success"
    },
    importFailed: {
        text: "Failed to import !!",
        toasterColor: "bg-danger",
        textColor: "text-danger"
    },
    export: {
        text: "Exported Successfully !!",
        toasterColor: "bg-success",
        textColor: "text-success"
    },
    exportFailed: {
        text: "Failed to export !!",
        toasterColor: "bg-danger",
        textColor: "text-danger"
    }
}

export const Active_Switch_Theme = {
    color: "#4d10b3"
}

export const cardStatus = (status: any) => {
    if (status == "Completed") {
        return "bg-success";
    }
    if (status == "Pending") {
        return "bg-warning";
    }
    if (status == "Delay") {
        return "bg-danger";
    }
    return '';
}

export const getTimeAgo = (dateStr: string): string => {
    try {
        const date = new Date(dateStr);
        const now = new Date();
        const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);

        if (diffInSeconds < 60) return `${diffInSeconds} seconds ago`;
        const diffInMinutes = Math.floor(diffInSeconds / 60);
        if (diffInMinutes < 60) return `${diffInMinutes} minute${diffInMinutes !== 1 ? 's' : ''} ago`;
        const diffInHours = Math.floor(diffInMinutes / 60);
        if (diffInHours < 24) return `${diffInHours} hour${diffInHours !== 1 ? 's' : ''} ago`;
        const diffInDays = Math.floor(diffInHours / 24);
        return `${diffInDays} day${diffInDays !== 1 ? 's' : ''} ago`;
    } catch (e) {
        return '';
    }
};

export const formatTableCell = (value: any, datatype: any) => {

    if (datatype == null) {
        return value;
    }
    if (datatype == "linkbtn") {
        return null;
    }
    if (datatype == "special") {
        return value;
    }
    else if (datatype === 'importBoolean') {
        return value == true ? 'Yes' : 'No';
    }
    else if (datatype === 'boolean') {
        return value == true ? 'Active' : 'InActive';
    }
    else if (datatype == 'status') {
        return value == true ? 'Accepted' : 'Not-accepted';
    }
    else if (datatype === 'Amount') {
        return 'Rs.' + ' ' + value + '/-';
    }
    else if (datatype === 'int') {
        return value;
    }
    else if (datatype === 'date') {
        if (value === null) {
            return value;
        } else {
            return moment(value).format("DD-MM-YYYY");
        }
    }
    else if (datatype === 'datetime') {
        if (value === null) {
            return value;
        } else {
            return moment(value).format("DD-MM-YYYY HH:mm");
        }
    }
    else if (datatype === 'badge') {
        if (value === null) {
            return value;
        } else {
            return (
                <Badge
                    className={"font-size-11 badge-soft-info"}
                >
                    {value}
                </Badge>
            )
        }
    }
    else if (datatype === 'dateWithBadge') {
        if (value === null) {
            return value;
        } else {
            return (
                <div className="d-flex align-items-center">
                    <span>{moment(value).format("DD-MM-YYYY HH:mm")}</span>
                    <Badge className="ms-2 bg-light text-secondary" pill>
                        <small>{getTimeAgo(value)}</small>
                    </Badge>
                </div>
            )
        }
    }
}

export const TablePagePerView = {
    Count: 10
}

export const QuotaionStatusEnum = (quotationEnum: any) => {
    if (quotationEnum == "Draft") {
        return "Completed";
    }
    else if (quotationEnum == "Completed") {
        return "Cancelled"
    }
}

export const QuotationStatusModelPopup = (statusEnum: any) => {
    if (statusEnum == "Draft") {
        return "Confirm";
    }
    if (statusEnum == "Completed") {
        return "Cancel"
    }
}

export const currencyCode = (countryCode: any) => {
    if (countryCode == "IN") {
        return '₹';
    }
}

export const formatAmount = (amount: any) => {
    return currencyCode("IN") + ' ' + parseInt(amount).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}